<template>
    <div class="col-xl-4 col-lg-6 mx-auto">
        <div class="vertical-products">
            <div class="vertical-products-header">
                <a :href="link"><h4 class="section-title">{{ title }}</h4></a>
            </div>

            <div class="vertical-products-slider" ref="productsPlaceholder">
                <div v-for="(productChunks, index) in $chunk(products, 5)" :key="index" class="vertical-products-slide">
                    <ProductCardVertical v-for="product in productChunks" :key="product.id" :product="product"/>
                </div>
            </div>
            <div class="vertical-products-footer">
                <a :href="link"><div class="section-footer">{{ link_title }}</div></a>
            </div>
        </div>
    </div>
</template>

<script>
    import ProductCardVertical from '../ProductCardVertical.vue';

    export default {
        components: { ProductCardVertical },

        props: ['title', 'url','link','link_title'],

        data() {
            return {
                products: [],
            };
        },

        created() {
            $.ajax({
                method: 'GET',
                url: this.url,
            }).then((products) => {
                this.products = products;

                this.$nextTick(() => {
                    $(this.$refs.productsPlaceholder).slick(this.slickOptions());
                });
            });
        },

        methods: {
            slickOptions() {
                return {
                    rows: 0,
                    dots: false,
                    arrows: true,
                    infinite: true,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    rtl: window.EcomShop.rtl,
                };
            },
        },
    };
</script>
